var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollScreem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#69625d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wm_Prancheta 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,7a1,1,0,0,1-.71-.29l-5-5A1,1,0,0,1,1.71.29L6,4.59,10.29.29a1,1,0,1,1,1.42,1.42l-5,5A1,1,0,0,1,6,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollScreem);
export default __webpack_public_path__ + "static/media/rollScreem.96e78e74397e02d86a92eaad9f3863ee.svg";
export { ForwardRef as ReactComponent };